import { StrictMode } from 'react'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { withRouter } from 'react-router-dom' // keeping until we migrate to v6
import { Routes, Route } from 'react-router-dom-v5-compat'

import { ReduxWrappedNavigator } from '@buffer-mono/app-shell'
import LegacyNotifications from '@buffer-mono/legacy-bufferapp-notifications'

import { CommentsSidebar } from '~publish/components/CommentsSidebar'
import { FeedsAnnouncementDialog } from '~publish/components/FeedsAnnouncementDialog'
import { PublishSidebar } from '~publish/components/PublishSidebar'
import { RootLayout } from '~publish/components/RootLayout'
import { SplitProtected } from '~publish/components/SplitProtected'
import { AppPages } from '~publish/legacy/app-pages'
import ComposerPopover from '~publish/legacy/composer-popover'
import { AppModals } from '~publish/legacy/modals'
import { Notifications } from '~publish/legacy/notifications-provider/components/Notifications'
import TemporaryBanner from '~publish/legacy/temporary-banner'
import ThirdParty from '~publish/legacy/thirdParty'
import { WelcomeChecklistContainer } from '~publish/legacy/welcome-checklist/components/WelcomeChecklistContainer'
import { CommentsChannelConfigProvider } from '~publish/pages/Comments/CommentsChannelConfigContext'
import { ContentSidebar } from '~publish/pages/Create/components/ContentSidebar/ContentSidebar'
import SettingsSidebar from '~publish/pages/Settings/SettingsSidebar'

import LoadingGate from '../LoadingGate'

const ThirdPartyWithRouter = withRouter(ThirdParty)

const App = (): JSX.Element => {
  return (
    <CommentsChannelConfigProvider>
      <RootLayout>
        <RootLayout.Navbar>
          <ReduxWrappedNavigator hideNavigation={false} hideBanners={false} />
        </RootLayout.Navbar>
        <RootLayout.Sidebar>
          <StrictMode>
            <Routes>
              <Route path="/comments/*" element={<CommentsSidebar />} />
              <Route path="/create/*" element={<ContentSidebar />} />
              <Route path="/settings/*" element={<SettingsSidebar />} />
              <Route path="*" element={<PublishSidebar />} />
              {/* We need to have the Sidebar also match on these paths below so that it's
              descendent components can useParams properly. (See ChannelNavItem.tsx) */}
              <Route
                path="/channels/:id/calendar/:granularity/*"
                element={<PublishSidebar />}
              />
              <Route
                path="/all-channels/calendar/:granularity/*"
                element={<PublishSidebar />}
              />
            </Routes>
          </StrictMode>
        </RootLayout.Sidebar>
        <RootLayout.Main className="notranslate app-root">
          <LoadingGate>
            <TemporaryBanner />
            <ComposerPopover />
            <AppPages />
            <WelcomeChecklistContainer />
            <SplitProtected name="feeds_announcement">
              <FeedsAnnouncementDialog />
            </SplitProtected>
          </LoadingGate>
        </RootLayout.Main>
      </RootLayout>

      <Notifications />
      <LegacyNotifications />
      <AppModals />
      <ThirdPartyWithRouter />
    </CommentsChannelConfigProvider>
  )
}

export default DragDropContext(HTML5Backend)(App)
